import React, { useEffect, useMemo, useState } from 'react';
import { Alert, Box, Paper, Typography } from '@mui/material';
import ViewCarouselOutlinedIcon from '@mui/icons-material/ViewCarouselOutlined';
import { getProductModules } from '../../../services/ecommerceApi';
import type { CustomModule } from '../ECommercePage';
import HomePageContentCardsPanel from './HomePageContentCardsPanel';

interface MarketingPromoCardsProps {
  companyId: string;
  configId: string;
}

/**
 * Pazarlama > Kart Oluştur — sade kampanya banner kartları
 * (sol görsel + sağ renkli panel, 3 yan yana).
 */
const MarketingPromoCards: React.FC<MarketingPromoCardsProps> = ({ companyId, configId }) => {
  const [homepageModules, setHomepageModules] = useState<CustomModule[]>([]);

  useEffect(() => {
    if (!companyId) return;
    getProductModules(companyId)
      .then((response) => {
        const rows = Array.isArray(response?.data) ? response.data : [];
        const modules: CustomModule[] = rows
          .filter((row: any) => {
            const type = String(row?.moduleType || '').toLowerCase();
            return type !== 'content-cards' && type !== 'content-tags' && type !== 'faq-section';
          })
          .map((row: any) => ({
            id: row.id,
            tabName: row.tabName || row.sectionTitle || 'Modül',
            sectionTitle: row.sectionTitle || row.tabName || 'Modül',
            order: Number(row.displayOrder) || 0,
            settings: row.settingsJson ? JSON.parse(row.settingsJson) : {}
          }));
        setHomepageModules(modules);
      })
      .catch(() => setHomepageModules([]));
  }, [companyId]);

  const processedModules = useMemo(
    () =>
      homepageModules.filter(
        (module) =>
          module.tabName !== 'İçerik Kartları' &&
          module.tabName !== 'İçerik Etiketleri' &&
          String(module.id || '').length > 0
      ),
    [homepageModules]
  );

  if (!configId) {
    return (
      <Paper elevation={3} sx={{ p: 3 }}>
        <Alert severity="warning">
          Kart oluşturmak için önce Genel Ayarlar’dan e-ticaret yapılandırmasını kaydedin.
        </Alert>
      </Paper>
    );
  }

  return (
    <Paper elevation={3} sx={{ p: 3 }}>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
        <ViewCarouselOutlinedIcon color="primary" />
        <Typography variant="h5" fontWeight={700}>
          Kart Oluştur
        </Typography>
      </Box>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
        Daha büyük kampanya kartları. Konumu sol / orta / sağ kaydedilir; görsel yoksa kart solda indirim,
        sağda tarih ve CTA olacak şekilde değişir.
      </Typography>
      <HomePageContentCardsPanel
        companyId={companyId}
        configId={configId}
        homepageModules={processedModules}
        mode="promo"
      />
    </Paper>
  );
};

export default MarketingPromoCards;
